import {
  ISubtitleAttributes,
} from '@SiteModules/Subtitle/types'

export default function getAllowLinkToEditor(projectVersionIsDisabled: boolean, subtitleAttributes: ISubtitleAttributes): boolean {

  const {
    waitingForCompletionOfTranscript,
    stage,
  } = subtitleAttributes

  const allowLinkToEditorForUnprocessed =
    waitingForCompletionOfTranscript &&
    stage !== 'separating_audio' &&
    stage !== 'generating_diarization'

  const isProcessed = stage === 'done' || stage === 'new' || stage === 'waiting_review_for_voice_generation'

  return !projectVersionIsDisabled && (isProcessed || allowLinkToEditorForUnprocessed)
}
